import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

export default function FireStations(props) {
  const t = props.estatedProperty;
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Fire Stations
      </Typography>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Dept Type</TableCell>
            <TableCell>Org Type</TableCell>
            <TableCell>Career</TableCell>
            <TableCell>Paid Per Call</TableCell>
            <TableCell>Volunteer</TableCell>
          </TableRow>
          {t.fire_stations.map((fire_station, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{fire_station.fire_dept_name}</TableCell>
                <TableCell>{fire_station.dept_type}</TableCell>
                <TableCell>{fire_station.organization_type}</TableCell>
                <TableCell>{fire_station.active_firefighters_career}</TableCell>
                <TableCell>
                  {fire_station.active_firefighters_paid_per_call}
                </TableCell>
                <TableCell>
                  {fire_station.active_firefighters_volunteer}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
